import React, { useEffect, useState } from 'react';
import * as htoAnalytics from '../../hto-utils';
import localStorageHelper from '../../../../utils/localStorageHelper';

function HTOAppointmentSuccess(props) {
    const { appointmentInfo = {}, isPaymentCaptured } = props;
    const { cartPrice, agentName, agentNumber, orderid, estimatedTime } = appointmentInfo;
    const [appointmentType, setAppointmentType] = useState();
    const [htoBookLaterData, setHtoBookLaterData] = useState({});

    useEffect(() => {
        htoAnalytics.triggerDatalayer(props.orderId, props.amount);
        htoAnalytics.onSuccessPageLoad();
        const appointmentType = localStorageHelper.getItem('appointmentType') || {};
        setAppointmentType(appointmentType);
        if (appointmentType !== 'bookNow') {
            const htoBookLaterData = localStorageHelper.getItem('htoBookLaterData') || {};
            setHtoBookLaterData(htoBookLaterData);
        }
    }, []);

    const formatDate = date => {
        const dateObj = new Date(date);
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const day = dateObj.getDay();
        const month = dateObj.getMonth();
        const returnString = `${days[day]} ${months[month]} ${dateObj.getDate()}`;
        return returnString;
    };

    return (
        <div className="hto-appointment-success text-center pd-10">
            <picture>
                <img src="https://static5.lenskart.com/images/cust_mailer/Dec_10th/hto_appointment_confirmed.png" alt="home_try_on at_lenskart" style={{ maxWidth: '90px' }} />
            </picture>
            <div className="fsp16 fs24 text-uppercase padding-t10 padding-b10 pd-t10 pd-b10">Appointment Booked!</div>
            <p><div className="mr-b10 margin-b10">Thank you for choosing our service.</div>
                {appointmentType === 'bookNow' ?
                    <React.Fragment>
                        Your appointment <strong>{orderid}</strong> is confirmed with our optometrist <strong>{agentName}</strong> {Boolean(agentNumber) && <a href={`tel: ${agentNumber}`}><strong>[{agentNumber}]</strong></a>}. {Boolean(estimatedTime) && <span>He should reach you within <strong>{estimatedTime} minutes</strong>.</span>} {Boolean(cartPrice) && <span>Kindly pay fee of <strong>Rs. {Math.abs(cartPrice)}</strong> to the optometrist.</span>}
                    </React.Fragment> :
                    <React.Fragment>
                        Your appointment <strong>{props.orderId}</strong> has been booked for {htoBookLaterData.date && <strong>{formatDate(htoBookLaterData.date)}</strong>} at {htoBookLaterData.slotName && <strong>{htoBookLaterData.slotName}</strong>}.<p className="pd-t5">Please note this is only a preferred date & time. {Boolean(!isPaymentCaptured) && Boolean(props.amount) && <span>Kindly pay the fee of <strong>Rs. {Math.abs(props.amount)}</strong> to the optometrist.</span> }</p>
                    </React.Fragment>
                }
            </p>
            <div className="display-flex justify-content-center padding-b10 padding-t10 pd-b10 pd-t10">
                {appointmentType === 'bookNow' && <div onClick={() => props.navTo('cancel-appointment')} className="flex-1 hto-cancel-btn hto-btn hto-btn__dark margin-r5 mr-r5"><span>Cancel</span></div>}
                <a href="/" className="flex-1 hto-btn hto-btn__primary"><span>Alright, Thanks!</span></a>
            </div>
        </div>
    );
}


export default HTOAppointmentSuccess;
